import React from "react";
import { HashLink } from "react-router-hash-link";
import CloseIcon from "../assets/icon-close-menu.svg";
import HamburgerIcon from "../assets/icon-menu.svg";
import "./Navbar.css";

export default function Navbar(props) {
  return (
    <>
      <nav className="nav-container">
        <div id="menu-icon" onClick={props.toggleMenu}>
          {props.isMenuOpen ? (
            <img src={CloseIcon} alt="close icon" />
          ) : (
            <img src={HamburgerIcon} alt="menu icon" />
          )}
        </div>
        <ul className="nav-menu" id="menu">
          <li>
            <HashLink smooth to={"/#section-two"} onClick={props.toggleMenu}>
              Projects
            </HashLink>
          </li>
          <li>
            <HashLink smooth to={"/#section-three"} onClick={props.toggleMenu}>
              Contact
            </HashLink>
          </li>
        </ul>
      </nav>
    </>
  );
}
